import styled from 'styled-components';

export const Root = styled.div``;

export const Header = styled.header`
  margin: 0 auto;
  padding: 2rem 0;
`;

export const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const HeaderSearch = styled.div`
  padding-top: 1rem;
`;

export const Title = styled.h1`
  font-family: Open Sans;
  font-size: 28px;
  color: #000;
  margin: 0;
`;

export const LoadingMessage = styled.div``;

export const ErrorMessage = styled.div`
  color: red;
`;

export const EmptyMessage = styled.div``;

export const Footer = styled.footer`
  padding: 2rem 4rem;
  text-align: right;
`;

export const Buttons = styled.div`
  display: grid;
  grid-auto-flow: column;
  justify-content: end;
  grid-gap: 1rem;
`;

export const Description = styled.div``;
